// require jquery.min.js

// require what-input.min.js

// Core Foundation files
//=require foundation.core.min.js
//=require foundation.util.*.min.js

// require foundation.dropdown.min.js
// require foundation.responsiveMenu.min.js
// require foundation.responsiveToggle.min.js
//=require foundation.toggler.min.js
// require foundation.offcanvas.min.js
//
// to inlude foundation plugins add "=" sign below
//
// require foundation.abide.min.js
// require foundation.accordion.min.js
// require foundation.accordionMenu.min.js
// require foundation.drilldown.min.js
// require foundation.dropdownMenu.min.js
// require foundation.equalizer.min.js
// require foundation.interchange.min.js
// require foundation.magellan.min.js

// require foundation.reveal.min.js
// require foundation.slider.min.js
// require foundation.sticky.min.js
// require foundation.tabs.min.js
// require foundation.tooltip.min.js
// require foundation.zf.responsiveAccordionTabs.min.js

// require slick.min.js
//
// Google Map ACF functions
// require components/map.js
//=require components/slick.min.js

;
(function ($) {
    // init Foundation
    $(document).foundation();
    // flex Video
    // $( 'iframe[src*="youtube.com"]').wrap("<div class='flex-video widescreen'/>");
    // $( 'iframe[src*="vimeo.com"]').wrap("<div class='flex-video widescreen vimeo'/>");

    $(document).ready(function () {
        /* Generall slick slider*/
        $('.slick-arrow').text('');
        /* End generall slick slider*/

        /*Cbd basics section slider*/
        var $slider = $('.js-cbd-basics-posts');
        $slider.slick({
            arrows: false,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 3,
            centerMode: true,
            centerPadding: '0px',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: true,
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        centerMode: true,
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        slidesToShow: 2
                    },
                }
            ]
        });

        //slider for instagrom section
        var $instaSlider = $('.js-insta-post');
        $instaSlider.slick({
            arrows: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            centerMode: false,
            centerPadding: '0px',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: true,
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        centerMode: true,
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        slidesToShow: 2
                    },
                }
            ]
        });
        /*End cbd basics section slider*/

        /* Yotu-playlist dom manipulations*/
        // Cut Yuto Description
        var yutoDesc = $('.yotu-playing-description'),
            yutoDescText = yutoDesc.html(),
            lermMoreBtn = '<div class="navigation"><div class="link"><a href="' + 'https://www.youtube.com/channel/UCLXJrkXA58wRG3K2YlSBIkA/videos' + '" class="learn-more">Mehr Lesen</a></div></div>',
            lermMoreBtnBottom = '<div class="link"><a href="' + 'https://www.youtube.com/channel/UCLXJrkXA58wRG3K2YlSBIkA/videos' + '" class="learn-more">Mehr Lesen</a></div>';
        // if (yutoDescText.length > 200) {
        yutoDescText = yutoDescText.substring(0, 150) + '...';
        yutoDesc.html(yutoDescText);
        // }

        $('.videos').on('click', function (e) {
            if ($(e.target).parents('.yotu-video').length > 0) {
                var yutoDesc = $('.yotu-playing-description'), yutoDescText = yutoDesc.html();
                // if (yutoDescText.length > 200) {
                yutoDescText = yutoDescText.substring(0, 150) + '...';
                yutoDesc.html(yutoDescText);
                // }
            }
        });
        // End cut Yuto Description

        // Wrapp yotu-player divs in wrapper and other manipulations
        var yutoPlayer = $('.yotu-player'),
            yutoPaginationTop = $('.yotu-playlist .yotu-pagination-top'),
            yutoPaginationBottom = $('.yotu-playlist .yotu-pagination-bottom'),
            yutoPrevNextBtns = $('.yotu-button-prs');
        yutoDesc.after(lermMoreBtn);
        yutoPlayer.wrap('<div class="yotu-player-video-wrapper" />');
        yutoPaginationBottom.wrap('<div class="navigation-bottom" />');
        $(".yotu-wrapper-player>div:not(.yotu-player-video-wrapper)").wrapAll("<div class='yotu-player-meta-wrapper' />");
        yutoPaginationTop.prependTo(".yotu-player-meta-wrapper .navigation");
        yutoPaginationBottom.after(lermMoreBtnBottom);
        yutoPrevNextBtns.text('');
        // End wrapp yotu-player in wrapper
        /* End yotu-playlist dom manipulations*/


    });

    $(window).load(function () {

    });

    $(window).on('resize', function () {

    });

})(jQuery);


















